export const langs = [
  { value: 'en', label: 'English', countryCode: 'GB' },
  { value: 'cn', label: 'Chinese', countryCode: 'CN' },
  { value: 'hi', label: 'Hindi', countryCode: 'IN' },
  { value: 'pt', label: 'Portuguese', countryCode: 'PT' },
  { value: 'ko', label: 'Korean', countryCode: 'KR' },
  { value: 'ar', label: 'Arabic', countryCode: 'AR' },
  { value: 'es', label: 'Espanol', countryCode: 'ES' },
];
